<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="activityPerProduct" :options="activityPerProductReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { ACTIVITY_PER_PRODUCT_QUERY } from "@/graphql/queries/engagement.js";

export default {
  name: "ProductEngagement",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    gymBranch: {
      type: [Number, String],
    },
  },
  data() {
    return {
      activityPerProduct: null,
    };
  },
  computed: {
    activityPerProductReport() {
      let series = this.activityPerProduct.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [
            c["actionDate"],
            parseInt((parseInt(c["userCount"]) / parseInt(c["totalUserSample"])) * 100),
          ]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Activity per product - last 7 days",
        },
        xAxis: {
          categories: this.activityPerProduct[0].engagement.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "% of cohort",
          },
        },
        credits: {
          enabled: false,
        },

        series: series,
      };
    },
  },
  apollo: {
    activityPerProduct: {
      query: ACTIVITY_PER_PRODUCT_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          gymBranch: this.gymBranch,
        };
      },
    },
  },
};
</script>
